export const LOGIN_REQUEST = 'auth/LOGIN_REQUEST';

export const VERIFY_DEVICE_OTP_REQUEST = 'auth/VERIFY_DEVICE_OTP_REQUEST';

export const RESEND_OTP_REQUEST = 'auth/RESEND_OTP_REQUEST';

export const LOGOUT_REQUEST = 'auth/LOGOUT_REQUEST';

export const REGISTER_REQUEST = 'auth/REGISTER_REQUEST';
export const REGISTER_SUCCESS = 'auth/REGISTER_SUCCESS';

export const ACTIVATE_REQUEST = 'auth/ACTIVATE_REQUEST';

export const RESEND_ACTIVATION_EMAIL = 'auth/RESEND_ACTIVATION_EMAIL';

export const RESET_PASSWORD_REQUEST = 'auth/RESET_PASSWORD_REQUEST';

export const FORGOT_PASSWORD_REQUEST = 'auth/FORGOT_PASSWORD_REQUEST';

export const REFRESH_TOKEN_REQUEST = 'auth/REFRESH_TOKEN_REQUEST';
